export default __webpack_public_path__ + "static/manchester-0a32f8df0b4e9775f1375f86ee533f96.jpg";